import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule, CurrencyPipe, DatePipe, DecimalPipe} from '@angular/common';
import {AgGridModule} from 'ag-grid-angular';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
/* Material */
import {MatSortModule} from '@angular/material/sort';
import {CdkTableModule} from '@angular/cdk/table';
import {MatNativeDateModule} from '@angular/material/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatIconModule} from '@angular/material/icon';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
/* primeng */
import {InputTextModule} from 'primeng/inputtext';
import {RadioButtonModule} from 'primeng/radiobutton';
import {CheckboxModule} from 'primeng/checkbox';
import {DropdownModule} from 'primeng/dropdown';
import {ButtonModule} from 'primeng/button';
import {ListboxModule} from 'primeng/listbox';
import {CustomOverlayComponent} from '@irb-common/components/irebal-ag-grid-ent-avatar/custom-overlay/custom-overlay.component';
import {ToastModule} from 'primeng/toast';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TableModule} from 'primeng/table';
import {PanelModule} from 'primeng/panel';
import {ChartModule} from 'primeng/chart';
import {PickListModule} from 'primeng/picklist';
import {CardModule} from 'primeng/card';
import {MultiSelectModule} from 'primeng/multiselect';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {SliderModule} from 'primeng/slider';
import {EditorModule} from 'primeng/editor';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {DrawerModule} from 'primeng/drawer';
/* irb */
import {FooterComponent} from './components/footer/footer.component';
import {FooterDialogComponent} from './components/footer-dialog/footer-dialog.component';
import {BannerComponent} from './components/banner/banner.component';
import {BannerService} from './components/banner/banner.service';
import {OverlayComponent} from './components/overlay/overlay.component';
import {DialogComponent} from './components/dialog/dialog.component';
import {TooltipComponent} from './components/tooltip/tooltip.component';
import {TooltipContainerComponent} from './components/tooltip/tooltip-container.component';
import {TooltipDirective} from './components/tooltip/tooltip.directive';
import {CalltoactionComponent} from './components/calltoaction/calltoaction.component';
import {CalltoactionContainerComponent} from './components/calltoaction/calltoaction-container.component';
import {CalltoactionDirective} from './components/calltoaction/calltoaction.directive';
import {HoverPanelComponent} from './components/hover-panel/hover-panel.component';
import {HoverPanelContainerComponent} from './components/hover-panel/hover-panel-container.component';
import {HoverPanelDirective} from './components/hover-panel/hover-panel.directive';
import {HighlightPipe} from '@irb-common/pipes/HighlightPipe';
import {EasternTimePipe} from '@irb-common/pipes/EasternTimePipe';
import {NegativeNumberPipe} from '@irb-common/pipes/NegativeNumberPipe';
import {IrebalAgGridEntAvatarComponent} from './components/irebal-ag-grid-ent-avatar/irebal-ag-grid-ent-avatar.component';
import {PanelButtonComponent} from '@irb-common/components/panel-button/panel-button.component';
import {IrbCustomHeaderComponent} from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-custom-header.component';
import {IrbDefaultHeaderComponent} from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-default-header.component';
import {PortColFormatterComponent} from '@irb-common/components/irebal-ag-grid-ent-avatar/portcolformatter.component';
import {IrbAgNumberColumnFilterComponent} from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-number-column-filter/irb-ag-number-column-filter.component';
import {IrbCurrencyFormatterDirective} from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-number-column-filter/irb-currency-formatter.directive';
import {DeleteCellComponent} from '@irb-common/components/grid/renderers/delete.cell.component';
import {DeleteHeaderComponent} from '@irb-common/components/grid/renderers/delete.header.component';
import {RangeHeaderComponent} from '@irb-common/components/grid/renderers/range.header.component';
import {RangeCellComponent} from '@irb-common/components/grid/renderers/range.cell.component';
import {CallToActionCellComponent} from '@irb-common/components/grid/renderers/calltoaction.cell.component';
import {TruncateTooltipCellComponent} from '@irb-common/components/grid/renderers/truncatetooltip.cell.component';
import {SelectionCellComponent} from '@irb-common/components/grid/renderers/selection.cell.component';
import {MatchComponent} from '@irb-common/components/grid/renderers/match.cell.component';
import {DropdownEditorComponent} from '@irb-common/components/grid/editors/dropdown-editor.component';
import {NumberTextBoxEditorComponent} from '@irb-common/components/grid/editors/number-text-box-editor.component';
import {NumberTextBoxRendererComponent} from '@irb-common/components/grid/renderers/number-text-box.cell.component';
import {ValidationTextBoxEditorComponent} from '@irb-common/components/grid/editors/validation-text-box-editor.component';
import {ValidationTextBoxRendererComponent} from '@irb-common/components/grid/renderers/validation-text-box-renderer.component';
import {DropdownRendererComponent} from '@irb-common/components/grid/renderers/dropdown.cell.component';
import {DropdownFilterRendererComponent} from '@irb-common/components/grid/renderers/dropdown-filter.cell.component';
import {DropdownSearchRendererComponent} from '@irb-common/components/grid/renderers/dropdown-search.cell.component';
import {DropdownSearchMultipleRendererComponent} from '@irb-common/components/grid/renderers/dropdown-search-multiple.cell.component';
import {DropdownComponent} from '@irb-common/components/dropdown/dropdown.component';
import {DropdownFilterComponent} from '@irb-common/components/dropdown-filter/dropdown-filter.component';
import {DropdownFilterEditorComponent} from '@irb-common/components/grid/editors/dropdownFilter-editor.component';
import {IrbAgSetColumnFilterComponent} from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-set-column-filter/irb-ag-set-filter.component';
import {DataService} from '@irb-common/services/data.service';
import {IrbPickListComponent} from './components/pick-list/pick-list.component';
import {AltSecDropDownCellEditor} from '@irb/irb-editors/editor-portfolio/com-alt-securities-dropdown/com-alt-securities-dropdown-editor.component';
import {AltSecDropDownCellRenderer} from '@irb/irb-editors/editor-portfolio/com-alt-securities-dropdown/com-alt-securities-dropdown-renderer.component';
import {FileSelectorComponent} from './components/file-selector/file-selector.component';
import {IrbAgGridExportComponent} from './components/irebal-ag-grid-ent-avatar/irb-ag-grid-export/irb-ag-grid-export.component';
import {ValidationTextBoxComponent} from './components/validation-text-box/validation-text-box.component';
import {NumberTextBoxComponent} from './components/number-text-box/number-text-box.component';
import {IrbAgDateColumnFilterComponent} from './components/irebal-ag-grid-ent-avatar/irb-ag-date-column-filter/irb-ag-date-column-filter.component';
import {ComInlineEditComponent} from './components/inlineedit/inlineedit.component';
import {DropdownSearchComponent} from './components/dropdown-search/dropdown-search.component';
import {ArchiveCellComponent} from './components/grid/renderers/archive.cell.component';
import {ModelReadCellComponent} from './components/grid/renderers/model-read-cell.component';
import {DropdownSearchMultipleComponent} from './components/dropdown-search-multiple/dropdown-search-multiple.component';
import {ColorCategoryComponent} from '@irb-common/components/grid/renderers/color-category/color-category.component';
import {NumericEditorComponent} from '@irb-common/components/grid/editors/numeric-editor.component';
import {AlertDialogComponent} from './components/alert-dialog/alert-dialog.component';
import {ConfirmationDialogComponent} from './components/confirmation-dialog/confirmation-dialog.component';
import {DecodeHtmlPipe} from './pipes/DecodeHtmlPipe';
import {IrbHeaderGroupComponent} from '@irb-common/components/irebal-ag-grid-ent-avatar/header-group/header-group.component';
import {ProgressBarComponent} from './components/progress-bar/progress-bar.component';
import {SliderComponent} from '@irb-common/components/slider/slider.component';
import {OrderHistroyComponent} from '@irb/irb-editors/edit-trading-instructions/order-histroy/order-histroy.component';
import {DropdownSearchEditorComponent} from '@irb-common/components/grid/editors/dropdown-search-editor.component';
import {RequiredTextboxEditor} from '@irb-common/components/grid/editors/required-textbox-editor';
import {NumberInputValidatorComponent} from './components/number-input-validator/number-input-validator.component';
import {UpDownReorderCellComponent} from "@irb-common/components/grid/renderers/up-down-reorder.cell.component";
import {MMCFooterDialogComponent} from "@irb-common/components/mmc-footer-dialog/mmc-footer-dialog.component";
import {CheckboxCellComponent} from './components/grid/renderers/checkbox.cell.component';
import {IrbAgSingleSelectColumnFilterComponent} from "@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-single-select-column-filter/irb-ag-single-select-column-filter.component";
import {BooleanPipe} from '@irb-common/pipes/BooleanPipe';
import { FilterChipsComponent } from './components/filter-chips/filter-chips.component';
import { FilterChipElementComponent } from './components/filter-chips/filter-chip-element/filter-chip-element.component';
import { CustomNoRowOverlayComponent } from './components/irebal-ag-grid-ent-avatar/custom-norow-overlay/custom-norow-overlay.component';
import { FiltersForGridComponent } from './components/filters-for-grid/filters-for-grid.component';
import { EditorModelPrevnextComponent } from './components/editor-model-prevnext/editor-model-prevnext.component';
import { IrbAgSearchMultipleColumnFilterComponent } from './components/irebal-ag-grid-ent-avatar/irb-ag-search-multiple-column-filter/irb-ag-search-multiple-column-filter.component';
import { IrbInputFloatingFilterComponent } from './components/irebal-ag-grid-ent-avatar/irb-input-floating-filter/irb-input-floating-filter.component';
import { ExpandoLinkComponent } from './components/expando-link/expando-link.component';
import {MatchCustomTooltipComponent} from "@irb-common/components/grid/renderers/match-cutom-tooltip.component";


@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        AgGridModule,
        InputTextModule,
        RadioButtonModule,
        CheckboxModule,
        DropdownModule,
        ButtonModule,
        ListboxModule,
        MatButtonModule,
        MatCheckboxModule,
        MatDialogModule,
        MatMenuModule,
        MatSelectModule,
        MatTableModule,
        MatTabsModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSortModule,
        CdkTableModule,
        MatFormFieldModule,
        MatInputModule,
        MultiSelectModule,
        MatExpansionModule,
        MatCardModule,
        MatProgressBarModule,
        MatSidenavModule,
        MatSlideToggleModule,
        ToastModule,
        TableModule,
        PanelModule,
        ChartModule,
        FontAwesomeModule,
        PickListModule,
        CardModule,
        AutoCompleteModule,
        SliderModule,
        EditorModule,
        DrawerModule
    ],
    declarations: [
        AltSecDropDownCellRenderer,
        AltSecDropDownCellEditor,
        FooterComponent,
        FooterDialogComponent,
        MMCFooterDialogComponent,
        BannerComponent,
        OverlayComponent,
        DialogComponent,
        TooltipComponent,
        TooltipContainerComponent,
        TooltipDirective,
        CalltoactionComponent,
        CalltoactionContainerComponent,
        CalltoactionDirective,
        HoverPanelComponent,
        HoverPanelContainerComponent,
        HoverPanelDirective,
        HighlightPipe,
        EasternTimePipe,
        NegativeNumberPipe,
        IrebalAgGridEntAvatarComponent,
        IrbCustomHeaderComponent,
        IrbDefaultHeaderComponent,
        PortColFormatterComponent,
        IrbAgNumberColumnFilterComponent,
        IrbCurrencyFormatterDirective,
        DeleteCellComponent,
        DeleteHeaderComponent,
        RangeHeaderComponent,
        RangeCellComponent,
        CallToActionCellComponent,
        ArchiveCellComponent,
        TruncateTooltipCellComponent,
        SelectionCellComponent,
        CheckboxCellComponent,
        MatchComponent,
        CustomOverlayComponent,
        DropdownComponent,
        DropdownEditorComponent,
        DropdownSearchEditorComponent,
        NumberTextBoxEditorComponent,
        NumberTextBoxRendererComponent,
        ValidationTextBoxEditorComponent,
        ValidationTextBoxRendererComponent,
        DropdownRendererComponent,
        DropdownFilterRendererComponent,
        DropdownSearchRendererComponent,
        DropdownSearchMultipleRendererComponent,
        DropdownFilterComponent,
        PanelButtonComponent,
        DropdownFilterEditorComponent,
        IrbAgSetColumnFilterComponent,
        PanelButtonComponent,
        IrbPickListComponent,
        FileSelectorComponent,
        IrbAgGridExportComponent,
        ValidationTextBoxComponent,
        NumberTextBoxComponent,
        IrbAgDateColumnFilterComponent,
        ComInlineEditComponent,
        DropdownSearchComponent,
        ModelReadCellComponent,
        DropdownSearchMultipleComponent,
        ColorCategoryComponent,
        NumericEditorComponent,
        AlertDialogComponent,
        ConfirmationDialogComponent,
        DecodeHtmlPipe,
        IrbHeaderGroupComponent,
        ProgressBarComponent,
        SliderComponent,
        OrderHistroyComponent,
        RequiredTextboxEditor,
        NumberInputValidatorComponent,
        UpDownReorderCellComponent,
        CheckboxCellComponent,
        IrbAgSingleSelectColumnFilterComponent,
        BooleanPipe,
        FilterChipsComponent,
        FilterChipElementComponent,
        CustomNoRowOverlayComponent,
        FiltersForGridComponent,
        EditorModelPrevnextComponent,
        IrbAgSearchMultipleColumnFilterComponent,
        IrbInputFloatingFilterComponent,
        ExpandoLinkComponent,
        MatchCustomTooltipComponent
    ],
    exports: [
        OrderHistroyComponent,
        FormsModule,
        ReactiveFormsModule,
        FooterComponent,
        BannerComponent,
        OverlayComponent,
        DialogComponent,
        TooltipComponent,
        TooltipContainerComponent,
        TooltipDirective,
        CalltoactionComponent,
        CalltoactionContainerComponent,
        CalltoactionDirective,
        HoverPanelComponent,
        HoverPanelContainerComponent,
        HoverPanelDirective,
        HighlightPipe,
        EasternTimePipe,
        NegativeNumberPipe,
        IrebalAgGridEntAvatarComponent,
        IrbAgGridExportComponent,
        IrbCurrencyFormatterDirective,
        DropdownComponent,
        PanelButtonComponent,
        InputTextModule,
        RadioButtonModule,
        CheckboxModule,
        DropdownModule,
        ButtonModule,
        ListboxModule,
        DropdownFilterComponent,
        MatButtonModule,
        MatCheckboxModule,
        MatDialogModule,
        MatMenuModule,
        MatSelectModule,
        MatTableModule,
        MatTabsModule,
        MatProgressSpinnerModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSortModule,
        CdkTableModule,
        MatFormFieldModule,
        MatInputModule,
        MatExpansionModule,
        MatCardModule,
        MatProgressBarModule,
        MatSidenavModule,
        MatSlideToggleModule,
        ToastModule,
        TableModule,
        PanelModule,
        ChartModule,
        FontAwesomeModule,
        PickListModule,
        CardModule,
        ConfirmDialogModule,
        SliderModule,
        EditorModule,
        IrbPickListComponent,
        FileSelectorComponent,
        ValidationTextBoxComponent,
        NumberTextBoxComponent,
        ComInlineEditComponent,
        DropdownSearchComponent,
        DropdownSearchMultipleComponent,
        DecodeHtmlPipe,
        ProgressBarComponent,
        SliderComponent,
        NumberInputValidatorComponent,
        UpDownReorderCellComponent,
        BooleanPipe,
        FilterChipsComponent,
        FiltersForGridComponent,
        EditorModelPrevnextComponent,
        ExpandoLinkComponent,
        MatchCustomTooltipComponent,
        IrbAgDateColumnFilterComponent,
        DrawerModule
    ],
    providers: [BannerService, DecimalPipe, MessageService, DataService, ConfirmationService, DatePipe, CurrencyPipe, EasternTimePipe]
})
export class IrbCommonModule {
}
